interface Culture {
    language: 'nl',
    code: 'nl-NL'
}

export default () => ({ language: 'nl', code: 'nl-NL' } as Culture);
